import { Col, Row, RowProps } from 'antd';
import React, { useMemo } from 'react';
import { styled } from 'styled-components';
type D = RowProps & React.RefAttributes<HTMLDivElement>;
interface Props extends D {
  children?: React.ReactNode | React.ReactElement;
  containerClassName?: string;
  className?: string;
  offset?: {
    xs?: number;
    md?: number;
    lg?: number;
    xl?: number;
    xxl?: number;
  };
}
const Container: React.FC<Props> = ({ children = null, containerClassName, offset, className, ...props }) => {
  const _offset = useMemo(() => {
    if (offset) {
      return offset;
    }
    return ({
      xs: 23,
      md: 18,
      lg: 16,
      xl: 14,
      xxl: 12,
    });
  }, [offset]);
  return (
    <ContainerStyled {...props} className={containerClassName}>
      <Col flex={'auto'} {..._offset} className={className}>
        {children}
      </Col>
    </ContainerStyled>
  );
};

export default Container;
const ContainerStyled = styled(Row)`
  justify-content:center;
`;

